import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ASSET_TYPES } from 'client/utils/constants/assetTypes';

export const layersSlice = createSlice({
    name: 'assets',
    initialState: {
        originalLayers: {},
        layers: {},
        sensitiveAssets: []
    },
    reducers: {
        aggregateAssets: (state, action) => {
            const assets = action?.payload;
            if (typeof assets !== 'object' || assets === null) {
                return { ...state };
            }
            return {
                ...state,
                layers: { ...state.layers, ...assets.features },
                originalLayers: { ...state.originalLayers, ...assets.features },
                sensitiveAssets: state.sensitiveAssets.concat(assets.sensitiveFeatures || [])
            };
        },
        setAssets: (state, action) => {
            const assets = action?.payload;
            if (typeof assets !== 'object' || assets === null) {
                return { ...state };
            }
            return {
                ...state,
                layers: { ...assets.features },
                originalLayers: { ...assets.features },
                sensitiveAssets: assets.sensitiveFeatures || []
            };
        },
        filterAssets: (state, action) => {
            const filterFunction = action.payload?.filterFunction;
            let filteredLayers;
            if (!filterFunction) {
                filteredLayers = state.originalLayers;
            } else {
                filteredLayers = {};

                for (const layerName in state.originalLayers) {
                    state.originalLayers[layerName].forEach(function (feature) {
                        const matchingFeature = filterFunction(feature);
                        if (matchingFeature) {
                            filteredLayers[layerName] = filteredLayers[layerName] || [];
                            filteredLayers[layerName].push(feature);
                        }
                    });
                }
            }

            return {
                ...state,
                filteredLayers: filteredLayers
            };
        },
        clearAssets: (state, action) => {
            // Clears all layers. Logic did prior exist to delete individual layer, but was unused. Need to be aware of sensitive/redacted assets when clearing individual layers.
            return {
                ...state,
                originalLayers: {},
                layers: {},
                sensitiveAssets: []
            };
        }
    }
});

export const {
    aggregateAssets,
    setAssets,
    clearAssets,
    filterAssets
} = layersSlice.actions;

export default layersSlice.reducer;

// Memoised on `layers` so consumers only recompute when assets change
export const selectAssetIdsByDataProvider = createSelector(
    [state => state.assets?.layers],
    (layers = {}) => Object.keys(layers).reduce((acc, layerName) => {
        if (layerName === ASSET_TYPES.OBSERVATION) {
            return acc;
        }

        layers[layerName].forEach(feature => {
            const featureProps = feature.getProperties();
            const dataProviderId = featureProps?.dataproviderid_fk;
            const assetId = featureProps?.dataproviderassigneduniqueid;

            if (!dataProviderId || !assetId) {
                return;
            }

            acc[dataProviderId] = acc[dataProviderId] || [];
            if (!acc[dataProviderId].includes(assetId)) {
                acc[dataProviderId].push(assetId);
            }
        });

        return acc;
    }, {})
);
